var map = {
	"./de/btn-back.png": "/M35",
	"./en/btn-back.png": "MJGQ",
	"./es/btn-back.png": "b051",
	"./fr/btn-back.png": "M7nb",
	"./ja/btn-back.png": "gVXL",
	"./ko/btn-back.png": "tfSn",
	"./pt/btn-back.png": "Gcfe",
	"./ru/btn-back.png": "jYZ2",
	"./th/btn-back.png": "1I6L",
	"./zh-Hant/btn-back.png": "ZoSk"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0t15";